import {RootState} from "redux/store"

export const getCurrentEnvironment = (state: RootState) => state.appEnvironment?.environment

export const getCurrentEnvironmentId = (state: RootState) => state.environment.currentClientId as number

export const getCurrentMetaModel = (state: RootState) => state.environment.currentMetaModel
